module.exports = __webpack_public_path__ + "img/3.03ee80b7.jpg";